/* eslint-disable arrow-body-style */
// This is only applicable for Employee view of Netchex
import { Box } from '@chakra-ui/react';

import { isMobileView } from 'constants/isMobileView';
import { NETCHEX_SIDEPANEL_WIDTH } from 'constants/netChexConstants';

import { AccordionNavigation } from './components/netchex/AccordionNavigation';
import { MobileNav } from './components/netchex/MobileNav';

const NetchexPrimaryNav = () => {
  if (isMobileView()) {
    return <MobileNav />;
  }

  return (
    <>
      {/* JUST FOR EASIER SWITCHING PAGES IN DEVELOPMENT--------  REMOVE */}
      {/* <Box position="fixed" right={0} top={200} background="yellow.400">
        {Object.keys(EMPLOYEE_VIEW_MODULE_INTENTS_MAP)
          .map((key) => EMPLOYEE_VIEW_MODULE_INTENTS_MAP[key][0])
          .map(({ key, path, label }) => {
            return (
              <ChakraLink href={path} key={key}>
                <TextBodyMedium
                  style={{
                    padding: '2px',
                    fontSize: '8px',
                    fontWeight: 400,
                    borderBottom: '1px solid #d1d5db',
                  }}
                >
                  {label}
                </TextBodyMedium>
              </ChakraLink>
            );
          })}
      </Box> */}
      {/* JUST FOR DEVELOPMENT SWITCHING--------  REMOVE */}
      <Box w={NETCHEX_SIDEPANEL_WIDTH}>
        <AccordionNavigation />
      </Box>
    </>
  );
};

export { NetchexPrimaryNav };
